@if(!inMaintenanceMode()) {
  <router-outlet></router-outlet>
} @else {
  <div class="items-center flex flex-row justify-center h-screen">
    <h1>On ferme quelques instants pour un peu de maintenance (mais on reviens vite)</h1>
  </div>
}
